import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import moment from "moment"
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';

import { Paper, Table, TableContainer } from '@mui/material';
import CommonTableHeaderRow from '../../../components/Table/CommonTableHeaderRow';
import CommonTableBody from '../../../components/Table/CommonTableBody';

import { buttonsFocus, hasAccess, jsPdfDidParseCellCallback, jsPdfHeaderFooter, jsPdfWillDrawCellCallback } from '../../../components/generics/helper';
import { Loader } from '../../../components/generics/Loader';
import { callAddFontNirmalaBold } from '../../../styles/fonts/Nirmala-bold';
import { callAddFontNirmalaNormal } from '../../../styles/fonts/Nirmala-normal';
import { excelConfig, filterHeaderXlDataStyle, filterHeaderXlStyle } from '../../../configs/excelConfig';
import excelExport from '../../../services/exports/export-excel';

const FuelReportList = (props) => {
  const { filters, tableData } = props
  const { selectedRolesRights = [], adminType = 0 } = useSelector((state) => state.login?.userData);

  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const [isPdfLoading, setIsPdfLoading] = useState(false);

  const userData = useSelector((state) => state.login.userData);

  const tooltipStyle = {
    textAlign: 'left',
    width: '125px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }

  const FuelTypeCellRenderer = (row) => {
    if (row) {
      return row?.fuelType !== 0 ? <label title={`fuel Type: ${row?.fuelTypeTitle}`} style={tooltipStyle}>{row?.fuelTypeTitle}</label>
        : <label title={`Item Name: ${row?.itemName}`} style={tooltipStyle}>{row?.itemName}</label>
    }
  }

  const FSNameCellRenderer = (row) => {
    return row?.fuelStationName !== "" ?
      <label title={`Station Name: ${row?.fuelStationName}`} style={tooltipStyle}>{row?.fuelStationName}</label>
      : <label title={`store Name: ${row?.storeName}`} style={tooltipStyle}>{row?.storeName}</label >
  }
  let columnDefs = [
    { headerName: 'Fuel Date', field: 'fuelDate', headerSx: { width: '6%', borderTopLeftRadius: "6px", }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
    { headerName: 'Fuel Time', field: 'fuelTime', headerSx: { width: '6%', borderTopLeftRadius: "6px", }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
    { headerName: 'Vehicle No.', field: 'vehicleNo', headerSx: { width: '7.6%' }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
    { headerName: 'Vehicle Code', field: 'vehicleCode', headerSx: { width: "7.6%", textAlign: 'left' }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, sx: { textAlign: "left" }, allowSorting: false },
    { headerName: 'Starting KM', field: 'lastOdometer', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    { headerName: 'Ending KM', field: 'currentOdometer', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    { headerName: 'Fuel Type/ Item Name', field: 'fuelType-ItemName', cellRender: FuelTypeCellRenderer, headerSx: { width: '7.6%' }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false, tooltip: (params) => FuelTypeCellRenderer(params.data), },
    { headerName: 'Distance KM', field: 'runKM', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    { headerName: 'Fuel Qty', field: 'qty', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false, },
    { headerName: 'Rate', field: 'fuelRate', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'currency', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    { headerName: 'Total Amount', field: 'fuelAmount', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'currency', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    { headerName: 'AVG KM/L', field: 'avg', headerSx: { width: '7.6%', textAlign: 'right' }, xlCol: { dataType: 'number', dataFormatter: null, width: 20 }, sx: { textAlign: "right" }, allowSorting: false },
    { headerName: 'Fuel Station/ Fuel Store Name', field: 'fuelStation-FuelStore', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, cellRender: FSNameCellRenderer, headerSx: { width: '7.6%' }, allowSorting: false, tooltip: (params) => FSNameCellRenderer(params.data), },
    { headerName: 'Bill No', field: 'billNo', headerSx: { width: '7.6%' }, xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false, },
  ];

  let tallyExportColumnsDef = [
    { headerName: 'SR No .', field: 'srNo',  xlCol: { dataType: 'string', dataFormatter: null, width: 20 } },
    { headerName: 'Slip No', field: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false, },
    { headerName: 'Fuel Date', field: 'fuelDate', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
    { headerName: 'Party Name', field: 'fuelStation-FuelStore', xlCol: { dataType: 'string', dataFormatter: null, width: 50 },  },
    { headerName: 'Godown Name', field: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
    { headerName: 'Cost Center', field: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, width: 20 }, allowSorting: false },
    { headerName: 'Item', field: 'fuelType-ItemName', xlCol: { dataType: 'string', dataFormatter: null, width: 20 } },
    { headerName: 'Quantity', field: 'qty',  xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 }},
    { headerName: 'Rate', field: 'fuelRate', xlCol: { dataType: 'currency', dataFormatter: null, width: 20 } },
    { headerName: 'Amount', field: 'fuelAmount', xlCol: { dataType: 'currency', dataFormatter: null, width: 20 } },
    { headerName: 'Item Description', field: 'currentOdometer', xlCol: { dataType: 'number', dataFormatter: null, width: 20 } },
  ]

  const getFilterSectionData = () => {
    const fuelStoreColumns = [
      { header: 'Fuel Store Name', dataKey: 'fuelStoreName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: 'Fuel Item', dataKey: 'fuelItemName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: 'Bill No', dataKey: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
    ]
    const fuelStationColumns = [
      { header: 'Fuel Station Name', dataKey: 'fuelStationName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: 'Fuel Type', dataKey: 'fuelTypeName', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: 'Bill No', dataKey: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
    ]
    const allColumns = [
      { header: 'Bill No', dataKey: 'billNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 1 } },
    ]
    const combinedColumns = [
      { header: 'Report Type', dataKey: 'reportFor', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: filters.dateType === 'FuelDate' ? 'Fuel From Date' : 'Transaction Entry From Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: filters.dateType === 'FuelDate' ? 'Fuel To Date' : 'Transaction Entry To Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: 'Vehicle No.', dataKey: 'vehicleNo', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
      { header: 'Fuel From', dataKey: 'fuelFrom', xlCol: { dataType: 'string', dataFormatter: null, colSpan: 2 } },
    ]
    if (filters.fuelIssuedFrom === 1) {
      combinedColumns.push(...fuelStoreColumns)
    } else if (filters.fuelIssuedFrom === 2) {
      combinedColumns.push(...fuelStationColumns)
    } else {
      combinedColumns.push(...allColumns)
    }
    return {
      filterHeaderXlStyle,
      filterHeaderXlDataStyle,
      filterData: [
        {
          columns: combinedColumns,
          pdfColumnStyles: {
            0: { cellWidth: 50, halign: 'left', fontSize: 10 },
            1: { cellWidth: 50, halign: 'left', fontSize: 10 },
            2: { cellWidth: 50, halign: 'left', fontSize: 10 },
            3: { cellWidth: 50, halign: 'left', fontSize: 10 },
            4: { cellWidth: 50, halign: 'left', fontSize: 10 },
            5: { cellWidth: 50, halign: 'left', fontSize: 10 },
            6: { cellWidth: 50, halign: 'left', fontSize: 10 },
            7: { cellWidth: 50, halign: 'left', fontSize: 10 },
          },
          data: [
            {
              reportFor: filters.searchReportViewName,
              fromDate: moment(filters.fromDate).format('DD-MMM-YY'),
              toDate: moment(filters.toDate).format('DD-MMM-YY'),
              vehicleNo: filters.searchVehicleIds === '' ? 'All Vehicles' : filters.searchVehicleNos.length === 1 ? filters.searchVehicleNos[0] : `Multiple [${filters.searchVehicleNos.length}]`,
              fuelFrom: filters.fuelIssuedFrom === "" ? 'All' : filters.fuelIssuedFrom === 1 ? 'Fuel Store' : filters.fuelIssuedFrom === 2 ? 'Fuel Station' : '',
              fuelStoreName: filters.searchStoreNames.length === 0 ? 'All Fuel Stores' : filters.searchStoreNames.length === 1 ? filters.searchStoreNames[0] : `Multiple [${filters.searchStoreNames.length}]`,
              fuelItemName: filters.searchItemNames.length === 0 ? 'All Fuel Items' : filters.searchItemNames.length === 1 ? filters.searchItemNames[0] : `Multiple [${filters.searchItemNames.length}]`,
              fuelStationName: filters.searchFuelStationNames.length === 0 ? 'All Fuel Stations' : filters.searchFuelStationNames.length === 1 ? filters.searchFuelStationNames[0] : `Multiple [${filters.searchFuelStationNames.length}]`,
              fuelTypeName: !filters.searchFuelStationTypes || filters.searchFuelStationTypes === '' ? 'All Fuel Types' : filters.searchFuelStationTypeNames.join(', '),
              billNo: filters.searchBillNo,
            }
          ]
        },
      ]
    }
  }
  const printReport = () => {
    try {
      const filterSectionData = getFilterSectionData();
      setIsPdfLoading(true);
      setIsPdfLoaded(false);
      const pdfColumns = columnDefs.filter((col) => !col.hideForExport).map((col) => {
        return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
      });
      const pdfData = tableData?.map((item) => ({
        ...item,
        'fuelType-ItemName': item.issuedFrom === 1 ? item.itemName : item?.fuelTypeTitle,
        'fuelStation-FuelStore': item.issuedFrom === 1 ? item.storeName : item?.fuelStationName,
      }))
      jsPDF.API.events.push(["addFonts", callAddFontNirmalaBold]);
      jsPDF.API.events.push(["addFonts", callAddFontNirmalaNormal]);
      const doc = new jsPDF({
        orientation: 'l',
        format: 'a3',
      });
      var totalPagesExp = '{total_pages_count_string}';
      doc.autoTableSetDefaults({
        headStyles: { fontSize: 9, halign: 'left', fillColor: [30, 89, 167], },
      });

      doc.setProperties({
        title: `FuelReport-${moment().format('DD-MMM-YY-HH-mm')}.pdf`,
        subject: "Fuel Report",
        author: "Maven Tech Labs Pvt. Ltd.",
        keywords: "maven tech, Maintenance system, fuel report",
        creator: "MTLPL",
      });

      autoTable(doc, {
        margin: { top: 20, left: 5, right: 5, bottom: 5 },
        columns: filterSectionData.filterData[0].columns,
        body: filterSectionData.filterData[0].data,
        columnStyles: filterSectionData.filterData[0].pdfColumnStyles,
        theme: 'grid',
        tableWidth: 'wrap',
      });

      doc.line(0, doc.lastAutoTable.finalY + 2, doc.getPageWidth(), doc.lastAutoTable.finalY + 2);
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 4,
        margin: { top: 2, left: 5, right: 5, bottom: 5 },
        alternateRowStyles: {
          fillColor: [255, 255, 255]
        },
        columns: pdfColumns,
        body: pdfData,
        columnStyles: {
          0: { minCellWidth: 26, fontSize: 8 },
          1: { minCellWidth: 26, fontSize: 8 },
          2: { minCellWidth: 26, fontSize: 8 },
          3: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          4: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          5: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          6: { minCellWidth: 26, fontSize: 8 },
          7: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          8: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          9: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          10: { minCellWidth: 26, fontSize: 8, halign: 'right' },
          11: { minCellWidth: 26, fontSize: 8 },
          12: { minCellWidth: 26, fontSize: 8 },
          13: { minCellWidth: 26, fontSize: 8 },
        },
        theme: 'grid',
        showHead: 'everyPage',
        headStyles: {
          fillColor: [30, 89, 167],
        },
        didParseCell: (data) => {
          jsPdfDidParseCellCallback(data, pdfColumns);
        },
        willDrawCell: (data) => {
          jsPdfWillDrawCellCallback(data);
        },
        didDrawPage: function (data) {
          data.settings.margin.top = 16;
          const reportTitle = `Maintenance System | Fuel Report`
          jsPdfHeaderFooter(data, reportTitle, userData, totalPagesExp);
        },
      },
      );
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      setIsPdfLoaded(true);
      setTimeout(() => {
        // document.getElementById('output').data = doc.output('datauristring', 'FuelReport.pdf');
        const blob = doc.output('blob');
        const url = URL.createObjectURL(blob);
        document.getElementById('output').data = url;
        setIsPdfLoading(false);
      }, 1000);
    } catch (err) {
      console.log(err);
      setIsPdfLoading(false);
      setIsPdfLoaded(false);
    }
  }
  const backToScreenView = () => {
    setIsPdfLoaded(false);
  }
  const reportExcelExport = async () => {
    try {
      const filterSectionData = getFilterSectionData();
      setIsPdfLoading(true);
      const xlColumns = columnDefs.filter((col) => !col.hideForExport).map((col) => {
        return { colHeader: col.headerName, field: col.field, xlCol: col.xlCol }
      });
      const excelData = tableData?.map((item) => ({
        ...item,
        'fuelType-ItemName': item.issuedFrom === 1 ? item.itemName : item?.fuelTypeTitle,
        'fuelStation-FuelStore': item.issuedFrom === 1 ? item.storeName : item?.fuelStationName,
      }))
      const reportTitle = `Maintenance System | Fuel Report`
      const xlConfig = {
        ...excelConfig,
        columns: xlColumns,
        fileName: `Fuel_Report_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.xlsx`,
        showFilterSection: true,
        filterSectionData,
        workSheetTitle: `Fuel Report`,
        headerFooter: {
          firstHeader: `&L&14&K104FA2 ${reportTitle} &R&B&12 Company Name: ${userData.companyName}`,
          firstFooter: `&L&12 Report By : ${userData.userFullName}  [ ${userData.branchName} ] &C&12 Report Time :  ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")} &R&12 Page: &P of &N`
        },
        sheetHeaderData: [{
          "caption": "Report Name :",
          "value": `Fuel Report`,
          "colSpan": 7
        }, {
          "caption": "Company Name :",
          "value": userData.companyName,
          "colSpan": 6
        }],
      };
      await excelExport.processExcel(xlConfig, excelData);
      setIsPdfLoading(false);
    } catch (err) {
      console.log(err);
      setIsPdfLoading(false);
    }
  }

  const tallyExcelExport = async () => {
    try {
      setIsPdfLoading(true);
      const xlColumns = tallyExportColumnsDef.filter((col) => !col.hideForExport).map((col) => {
        return { colHeader: col.headerName, field: col.field, xlCol: col.xlCol }
      });
      const lastRow = tableData[tableData.length-1];
      if(lastRow.isTotalRow){
        tableData.pop();
      }
      const excelData = tableData?.map((item) => ({
        ...item,
        'fuelStationName':item.fuelStationName.toUpperCase(),
        'vehicleNo':item.vehicleNo.replace(/[ -//]/g,''),
        'fuelDate': moment(item.fuelDateTime).format('DD-MM-YYYY HH:mm:ss'),
        'fuelType-ItemName': item.issuedFrom === 1 ? item.itemName : item?.fuelTypeTitle,
        'fuelStation-FuelStore': item.issuedFrom === 1 ? item.storeName : item?.fuelStationName,
      }))
      const reportTitle = `Maintenance System | Fuel Report`
      const xlConfig = {
        ...excelConfig,
        columns: xlColumns,
        fileName: `Fuel_Report_${moment(new Date()).format("DD_MMM_YYYY_ddd_HH_mm")}.xlsx`,
        showFilterSection: false,
        workSheetTitle: `Fuel Report`,
        headerFooter: {
          firstHeader: `&L&14&K104FA2 ${reportTitle} &R&B&12 Company Name: ${userData.companyName}`,
          firstFooter: `&L&12 Report By : ${userData.userFullName}  [ ${userData.branchName} ] &C&12 Report Time :  ${moment(new Date()).format("DD MMM YYYY, ddd, HH:mm")} &R&12 Page: &P of &N`
        },
        // sheetHeaderData: [{
        //   "caption": "Report Name :",
        //   "value": `Fuel Report`,
        //   "colSpan": 7
        // }, {
        //   "caption": "Company Name :",
        //   "value": userData.companyName,
        //   "colSpan": 6
        // }],
      };
      await excelExport.processExcel(xlConfig, excelData);
      setIsPdfLoading(false);
    } catch (err) {
      console.log(err);
      setIsPdfLoading(false);
    }
  }

  return (
    <>
      {tableData.length > 0 && <>
        <div className='report--header--container'>
          <div key="clss_report_name" className='report--for--heading'>Fuel Report</div>
          <div key="clss_report_action_container" className="report-export-button--container">
            {!isPdfLoaded && <>
              {hasAccess(selectedRolesRights, '4082', adminType) && <div key="clss_xls_btn" id="cssEpExCel" tabIndex={0} className="dashed--btn" onClick={() => tallyExcelExport()} onKeyDown={(e) => buttonsFocus(e, reportExcelExport, `cssEpAsPDF`, `cssfSearchBtn`, "EX", "cssfSearchBtn")}> TALLY EXPORT </div>}
              {hasAccess(selectedRolesRights, '4082', adminType) && <div key="clss_xls_btn" id="cssEpExCel" tabIndex={0} className="dashed--btn" onClick={() => reportExcelExport()} onKeyDown={(e) => buttonsFocus(e, reportExcelExport, `cssEpAsPDF`, `cssfSearchBtn`, "EX", "cssfSearchBtn")}> EXPORT AS EXCEL </div>}
              {hasAccess(selectedRolesRights, '4083', adminType) && <div key="clss_xpdf_btn" id="cssEpAsPDF" tabIndex={0} className="dashed--btn" onClick={() => printReport()} onKeyDown={(e) => buttonsFocus(e, printReport, `cssEpExPDF`, `cssEpExCel`, null)}> EXPORT AS PDF </div>}
              {hasAccess(selectedRolesRights, '4081', adminType) && <div key="clss_prn_btn" id="cssEpExPDF" tabIndex={0} className="dashed--btn" onClick={() => printReport()} onKeyDown={(e) => buttonsFocus(e, printReport, `cssSumList0`, `cssEpAsPDF`, null)}> PRINT </div>} </>}
            {isPdfLoaded && <><div key="clss_backBtn" className="dashed--btn" onClick={() => backToScreenView()}> Back </div> </>}
            {isPdfLoading && <div key="clss_loading_container" style={{ width: "100px", textAlign: 'center', marginTop: '10px' }}><Loader /></div>}
          </div>
        </div>
        {!isPdfLoaded && !isPdfLoading && <>
          <TableContainer component={Paper} className="jc--scroll jobCrdPreviewModel" style={{ maxHeight: '500px' }} >
            <Table id="fuelReport" sx={{ minWidth: 1500, zIndex: 2 }} stickyHeader aria-label="sticky table">
              <CommonTableHeaderRow columnDefs={columnDefs} />
              <CommonTableBody rows={tableData} keyField={'fuelVoucherId'} tableRowStyle={{}} columnDefs={columnDefs}
                totalRecords={tableData?.length}
                rowsPerPage={tableData?.length}
                page={0}
              />
            </Table>
          </TableContainer>
        </>}
      </>}

      {isPdfLoaded && <object id="output" type="application/pdf" width="100%" height="600" title="MTLPL - Maintenance System - Fuel Report" aria-label="MTLPL - Maintenance System - Fuel Report"></object>}
    </>
  )
}

export default FuelReportList
